module.exports = __webpack_public_path__ + "img/home-but1.d9036e6b.png";